export default __webpack_public_path__ + "656756607d7d8600d9bb209392f0bd01.jpg";